export default __webpack_public_path__ + "static/media/Bone Loop.5a70689c.jpg";